import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Auth } from 'aws-amplify';
import { SsoService } from 'src/app/services/sso.service';
import { selectSchool } from 'src/app/store';
import { setSchoolName } from 'src/app/store/auth.actions';

@Component({
  selector: 'ets-sso-redirect',
  templateUrl: './sso-redirect.component.html',
  styleUrls: ['./sso-redirect.component.scss'],
})
export class SsoRedirectComponent implements OnInit {
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private ssoService: SsoService,
    private store: Store
  ) {}

  async ngOnInit(): Promise<void> {
    let authenticatedUser: any = null;
    try {
      authenticatedUser = await Auth.currentAuthenticatedUser();
    } catch (error) {
      authenticatedUser = null;
    }

    if (authenticatedUser) {
      this.route.queryParams.subscribe(async (params) => {
        if (localStorage.getItem('insightsDetails')) {
          const details = JSON.parse(localStorage.getItem('insightsDetails')!);
          const sid = params['sid'];
          try {
            if (details.studentId !== atob(sid)) {
              localStorage.removeItem('insightsDetails');
              localStorage.setItem(
                'insightsDetails',
                JSON.stringify({
                  studentId: atob(params['sid']) || '',
                  userType: atob(params['r']) || '',
                })
              );
            }
          } catch(error){
            console.log('error: ', error);
            this.router.navigate(['/dashboard']);
          }
        }
        let school;
        try {
          if (params['s']) {
            school = atob(params['s']);
            this.store.dispatch(setSchoolName({ payload: school }));
          } else if (localStorage.getItem('loginDetails')) {
            const lgnDetitem = localStorage.getItem('loginDetails');
            const loginDetails = lgnDetitem ? JSON.parse(lgnDetitem) : null;
            school = loginDetails?.school;
            this.store.dispatch(setSchoolName({ payload: school }));
          } else {
            await this.store.select(selectSchool).subscribe((school) => {
              if (school) {
                this.store.dispatch(setSchoolName({ payload: school }));
              } else if (localStorage.getItem('pendoData')) {
                this.store.dispatch(
                  setSchoolName({
                    payload: JSON.parse(localStorage.getItem('pendoData')!).account.id
                  })
                );
              }
            });
          }
          await this.ssoService.postLoginRedirect();
        } catch (error) {
          console.log('error: ', error);
          this.router.navigate(['/dashboard']);
        }
      });
    } else {
      if (localStorage.getItem('insightsDetails')) {
        localStorage.removeItem('insightsDetails');
      }
      this.route.queryParams.subscribe((params) => {
        const to = params['to'];
        const s = params['s'];
        const studentId = params['sid'];
        const userType = params['r'];
        if (to) {
          try {
            if (userType && studentId) {
              localStorage.setItem(
                'insightsDetails',
                JSON.stringify({
                  studentId: atob(studentId) || '',
                  userType: atob(userType) || '',
                })
              );
            }
            this.ssoService.initiateLoginProcess(to, s);
          } catch (error) {
            console.log('error: ', error);
            this.router.navigate(['/dashboard']);
          }
        }
      });
    }
  }
}
